import functions from "../util/functions";

const banco = functions.databaseConfig();

const reqCliente = {
	vendasPorTipo: function (api, dataIni, dataFim, tipoData) {
		return api
			.get("v2/relatorios/clienteportipo", {
				params: {
					dataini: dataIni,
					datafim: dataFim,
					tipoData,
				},
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listar: function (api, param, paramValue, active) {
		return api
			.get("v2/cliente", {
				params: {
					param,
					paramValue,
					active,
				},
				headers: {
					banco: banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
	listPaginate: function (api, param, paramValue, active, page) {
		return api
			.get("v3/cliente", {
				params: {
					param,
					paramValue,
					active,
				},
				headers: {
					banco: banco,
					page,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},

	insert: function (api, data) {
		return api
			.post("v2/cliente", data, {
				headers: {
					banco,
				},
			})
			.then((response) => {
				return response;
			})
			.catch((error) => {
				throw error;
			});
	},
};

export default reqCliente;
